import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supplierApi, type SupplierDashboard } from '../../api/supplier';

const NAV = [
  { to: '/suppliers/directory', label: 'Directory' },
  { to: '/suppliers/onboarding', label: 'Onboarding' },
  { to: '/suppliers/contracts', label: 'Contracts' },
  { to: '/suppliers/compliance', label: 'Compliance' },
  { to: '/suppliers/performance', label: 'Performance' },
  { to: '/suppliers/risk', label: 'Risk' },
  { to: '/suppliers/analytics', label: 'Analytics' },
];

export function SupplierHubPage() {
  const [dashboard, setDashboard] = useState<SupplierDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void supplierApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Total suppliers', value: dashboard.total_suppliers },
        { label: 'Active', value: dashboard.active_suppliers },
        { label: 'Pending approval', value: dashboard.pending_approval },
        { label: 'High risk', value: dashboard.high_risk },
        { label: 'Expiring certs', value: dashboard.expiring_certs },
        { label: 'Avg health', value: `${dashboard.avg_health_score.toFixed(0)}%` },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Supplier Relationship Management</h1>
      <p className="mt-1 text-sm text-slate-600">Onboarding, compliance, contracts, performance, risk and AI intelligence.</p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => <Link key={l.to} to={l.to} className="text-slate-700 hover:underline">{l.label}</Link>)}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value ?? 0)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
